import React, { useState, useEffect, useContext } from 'react';
import { Input, Select_simple } from './ui';
import Select from "react-select";

import InfoButtonWithPopover from "./InfoButtonWithPopover";
import { AuthContext } from '../context/authContext';

import {
    optionsEncargadoProyecto, optionsTipoSubsidio,
    optionsProgramaUNO, optionsProgramaDOS, optionsProgramaTRES, optionsProgramaCUATRO, optionsProgramaCINCO, optionsProgramaSEIS,
    optionsAreaResponsable, optionsEstado, optionsPartido,
    optionsModalidadUNO, optionsModalidadDOS, optionsModalidadCUATRO, optionsModalidadCUATRO_UNO, optionsModalidadSEIS
} from '../datos/options';

import { AREA_RESP_OBRAS, AREA_RESP_MEJORAS, AREA_RESP_MICROCREDITOS, AREA_RESP_INTERVENCION_SOCIAL, AREA_RESP_CAPACITACIONES, AREA_RESP_OTRA } from "../constants/config";

// 2. CONSTANTES LOCALES (Fuera del componente para que no se re-creen al renderizar)
const PROGRAM_OPTIONS_MAP = {
    [AREA_RESP_OBRAS]: optionsProgramaUNO, // por ahora hardcodear
    [AREA_RESP_MEJORAS]: optionsProgramaDOS,
    [AREA_RESP_MICROCREDITOS]: optionsProgramaTRES,
    [AREA_RESP_INTERVENCION_SOCIAL]: optionsProgramaCUATRO,
    [AREA_RESP_CAPACITACIONES]: optionsProgramaSEIS,
    [AREA_RESP_OTRA]: optionsProgramaCINCO
};

const FiltrosInicio = ({
    filters,
    setFilters,
    data,//datosOriginales,
    datosFiltrados,
    handleSelectChange,
    handleFilterChange,
    limpiarFiltros,
    busquedaSemanticaQuery,
    setBusquedaSemanticaQuery,
    onBusquedaSemantica,
    onVerTodas,
    onAbrirBusquedaAvanzada,
    buscandoSemantico,
    resultadosSemanticos,
    onToggleFeedback,
    onReindexarSemantico,
    reindexandoSemantico
}) => {
    const { role } = useContext(AuthContext);
    const esAdmin = role === 'admin';

    console.log("DATA --->", data)

    const [partidosUnicos, setPartidosUnicos] = useState([]); //para partido_nombre
    const [organismosSolicitanteUnicos, setOrganismosSolicitanteUnicos] = useState([]); //para organismo_solicitante
    //por ahora no usar
    //const [estadosUnicos, setEstadosUnicos] = useState([]);
    //const [programasUnicos, setProgramasUnicos] = useState([]);


    // 1. función genérica
    const getUniqueAndFormattedItems = (data, propertyName) => {
        // Extrae y filtra los valores no vacíos o nulos
        const filteredItems = data
            .map(item => item[propertyName])
            .filter(item => item && item !== '');

        // Crea un Set con los valores únicos
        const uniqueItems = new Set(filteredItems);

        // Convierte el Set a un array y formatea los objetos
        /*return Array.from(uniqueItems).map(item => ({
            value: item,
            label: item
        }));*/

        // Ordenar alfabéticamente antes de formatear
        return Array.from(uniqueItems)
            .sort((a, b) => a.localeCompare(b)) // Orden alfabético
            .map(item => ({
                value: item,
                label: item
            }));
    };

    // buscar el objeto para mostrarlo en el Select
    const selectedValue = organismosSolicitanteUnicos.find(option => option.value === filters.organismo_solicitante || null);

    // 2. Unifica los efectos en un solo useEffect
    useEffect(() => {
        // Obtén y actualiza los partidos únicos
        const partidosUnicos = getUniqueAndFormattedItems(data, 'partido_nombre');//NO SE USA, usar optionsPartido
        setPartidosUnicos(partidosUnicos);

        // Obtén y actualiza los organismos solicitante únicos
        const organismosSolicitanteUnicos = getUniqueAndFormattedItems(datosFiltrados, 'organismo_solicitante'); //probar con datosFiltrados
        console.log("ORGANISMOS SOLICITANTE UNICOS --->", organismosSolicitanteUnicos)
        setOrganismosSolicitanteUnicos(organismosSolicitanteUnicos);

        // Obtén y actualiza los estados únicos
        //const estadosUnicos = getUniqueAndFormattedItems(data, 'estado');
        //setEstadosUnicos(estadosUnicos);

        //const programasUnicos = getUniqueAndFormattedItems(data, 'programa_lineamiento');
        //setProgramasUnicos(programasUnicos);

    }, [data, datosFiltrados]); // El efecto se ejecuta solo cuando 'data' cambia



    return (
        <div className="mb-6 p-4 bg-white dark:bg-gray-800 rounded-lg shadow-sm">
            <div className="flex justify-between items-center mb-4">
                <h3 className="text-lg font-medium text-gray-900 dark:text-white">Filtros</h3>
                <div className="flex items-center gap-4">
                    {esAdmin && (
                        <button
                            onClick={onToggleFeedback}
                            className="px-3 py-1 text-sm text-gray-600 hover:text-gray-800 dark:text-gray-300 dark:hover:text-white"
                            title="Ver valoraciones de la búsqueda semántica"
                        >
                            Valoraciones
                        </button>
                    )}
                    <button
                        onClick={limpiarFiltros}
                        className="px-3 py-1 text-sm text-blue-600 hover:text-blue-800 dark:text-blue-400 dark:hover:text-blue-300"
                    >
                        Limpiar filtros
                    </button>
                </div>
            </div>

            {/* Búsqueda semántica integrada con el resto de los filtros (solo admin) */}
            {esAdmin && (
            <div className="mb-5 p-4 bg-blue-50 dark:bg-gray-700/40 rounded-md border border-blue-200 dark:border-blue-800">
                <label htmlFor="busqueda_semantica" className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">
                    Búsqueda semántica
                </label>
                <div className="flex items-center gap-2">
                    <input
                        type="text"
                        id="busqueda_semantica"
                        value={busquedaSemanticaQuery}
                        onChange={(e) => setBusquedaSemanticaQuery(e.target.value)}
                        onKeyDown={(e) => e.key === 'Enter' && onBusquedaSemantica()}
                        placeholder="Describí qué buscás (ej: obras de puesta en valor, plazas, infraestructura de servicios)…"
                        className="flex-1 px-4 py-3 text-base border border-gray-300 dark:border-gray-600 rounded-md shadow-sm focus:ring-blue-500 focus:border-blue-500 dark:bg-gray-700 dark:text-white"
                    />
                    <button
                        type="button"
                        onClick={onBusquedaSemantica}
                        disabled={buscandoSemantico}
                        className={`shrink-0 px-4 py-2 rounded-md text-sm font-medium transition-colors ${buscandoSemantico
                            ? 'bg-gray-300 text-gray-500 cursor-not-allowed'
                            : 'bg-blue-500 text-white hover:bg-blue-600'}`}
                    >
                        {buscandoSemantico ? "Buscando…" : "Buscar"}
                    </button>
                    <button
                        type="button"
                        onClick={onAbrirBusquedaAvanzada}
                        className="shrink-0 px-4 py-2 rounded-md text-sm font-medium transition-colors bg-white text-blue-600 border border-blue-300 hover:bg-blue-50 dark:bg-gray-800 dark:text-blue-300 dark:border-blue-700 dark:hover:bg-gray-700"
                        title="Buscar combinando criterios (partido, avance, pagos, monto, estado…)"
                    >
                        Avanzada
                    </button>
                </div>
                <div className="mt-3">
                    <button
                        type="button"
                        onClick={onReindexarSemantico}
                        disabled={reindexandoSemantico}
                        className={`px-3 py-1.5 rounded-md text-xs font-medium transition-colors ${reindexandoSemantico
                            ? 'bg-gray-300 text-gray-500 cursor-not-allowed'
                            : 'bg-blue-100 text-blue-700 hover:bg-blue-200 dark:bg-blue-900/30 dark:text-blue-300 dark:hover:bg-blue-900/50'}`}
                        title="Reindexa todas las obras en la base pgvector (primera vez o cuando cambien los datos)"
                    >
                        {reindexandoSemantico ? "Reindexando…" : "Reindexar buscador semántico"}
                    </button>
                </div>
                {resultadosSemanticos !== null && (
                    <div className="mt-2 flex items-center gap-3">
                        <p className="text-xs text-gray-500 dark:text-gray-400">
                            {resultadosSemanticos.length} resultado(s)
                        </p>
                        {(() => {
                            const meta = resultadosSemanticos[0] || {};
                            const recortado = meta._recortado;
                            const total = meta._total ?? resultadosSemanticos.length;
                            const completo = meta._listadoCompleto;
                            if (completo) {
                                return (
                                    <span className="text-xs text-green-600 dark:text-green-400">
                                        Listando todas las {total}
                                    </span>
                                );
                            }
                            if (recortado) {
                                return (
                                    <button
                                        type="button"
                                        onClick={onVerTodas}
                                        disabled={buscandoSemantico}
                                        className="px-3 py-1 text-xs rounded-md border border-blue-300 text-blue-700 hover:bg-blue-100 disabled:opacity-50 dark:border-blue-700 dark:text-blue-300 dark:hover:bg-blue-900/40"
                                        title="Muestra las primeras 20; listar todas las que cumplen los criterios"
                                    >
                                        {buscandoSemantico ? "Cargando…" : `Ver todas (${total})`}
                                    </button>
                                );
                            }
                            return null;
                        })()}
                    </div>
                )}
            </div>
            )}

            <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
                {/* Filtro por Encargado */}
                <div>
                    <label htmlFor="encargado_proyecto" className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">
                        Responsable
                    </label>
                    <Select_simple
                        id="encargado_proyecto"
                        name="encargado_proyecto"
                        value={filters.encargado_proyecto}
                        onChange={handleFilterChange}
                        options={optionsEncargadoProyecto}
                        placeholder="Todos los responsables"
                    //className="w-full p-2 border border-gray-300 dark:border-gray-600 rounded-md shadow-sm focus:ring-blue-500 focus:border-blue-500 dark:bg-gray-700 dark:text-white"
                    />
                </div>
                {/* Filtro por Partido */}
                <div>
                    <div className="flex items-center">
                        <label htmlFor="partido_nombre" className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">
                            Partido
                        </label>
                    </div>
                    <Select_simple
                        id="partido_nombre" optionsModalidadSEIS
                        name="partido_nombre"
                        value={filters.partido_nombre}
                        onChange={handleFilterChange}
                        //options={partidosUnicos}
                        options={optionsPartido}
                        placeholder="Todos los partidos"
                    //className="w-full p-2 border border-gray-300 dark:border-gray-600 rounded-md shadow-sm focus:ring-blue-500 focus:border-blue-500 dark:bg-gray-700 dark:text-white"
                    />
                </div>
                {/* Filtro por Organismo Solicitante */}
                <div>
                    <div className="flex items-center">
                        <label htmlFor="organismo_solicitante" className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">
                            ONGs
                        </label>
                        <InfoButtonWithPopover infoText="Solo se muestran las ONGs donde hay proyectos" />
                    </div>
                    <Select

                        id="organismo_solicitante"
                        name="organismo_solicitante"
                        value={organismosSolicitanteUnicos.find(opt => opt.value === filters.organismo_solicitante) || null}
                        onChange={handleSelectChange}
                        options={organismosSolicitanteUnicos}
                        placeholder="Todas las ONGs"
                        isClearable={true}
                    //className="w-full px-3 py-2 text-sm border border-gray-300 rounded-md focus:outline-none focus:border-blue-500 dark:bg-gray-800 dark:text-white dark:border-gray-700 h10"
                    />
                </div>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-3 gap-4 py-4">
                {/* Filtro por Area Responsable */}
                <div>
                    <label htmlFor="area_responsable" className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">
                        Área Responsable
                    </label>
                    <Select_simple
                        id="area_responsable"
                        name="area_responsable"
                        value={filters.area_responsable}
                        onChange={handleFilterChange}
                        options={optionsAreaResponsable}
                        placeholder="Todas los áreas responsables"
                    //className="w-full p-2 border border-gray-300 dark:border-gray-600 rounded-md shadow-sm focus:ring-blue-500 focus:border-blue-500 dark:bg-gray-700 dark:text-white"
                    />
                </div>

                {/* Filtro por Programa según el área responsable  usar PROGRAM_OPTIONS_MAP*/}
                {!filters.area_responsable && (
                    <div>
                        <label htmlFor="programa" className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">
                            Programa
                        </label>
                        <Select_simple
                            disabled
                            id="programa"
                            name="programa_lineamiento"
                            value={filters.programa_lineamiento}
                            placeholder="Seleccionar..."
                        />
                    </div>
                )}
                {
                    PROGRAM_OPTIONS_MAP[filters.area_responsable] && (
                        <div>
                            <label htmlFor="programa" className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">
                                Programa
                            </label>
                            <Select_simple
                                id="programa"
                                name="programa_lineamiento"
                                value={filters.programa_lineamiento}
                                onChange={handleFilterChange}
                                options={PROGRAM_OPTIONS_MAP[filters.area_responsable]}
                                placeholder="Seleccionar..."
                            />
                        </div>
                    )
                }

                {/* Filtro por Modalidad según el programa seleccionado */}

                {filters.area_responsable === AREA_RESP_OBRAS && filters.programa_lineamiento === "Financiamiento para la Mejora del Hábitat" && (
                    <div>
                        <label htmlFor="modalidad" className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">
                            Modalidad
                        </label>
                        <Select_simple
                            id="modalidad"
                            name="modalidad"
                            value={filters.modalidad || ''}
                            onChange={handleFilterChange}
                            options={optionsModalidadUNO}
                            placeholder="Seleccionar..."
                        />
                    </div>
                )}

                {filters.programa_lineamiento === "Mejoras Habitacionales Trabajar en la Casa" && (
                    <div>
                        <label htmlFor="modalidad" className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">
                            Modalidad
                        </label>
                        <Select_simple
                            id="modalidad"
                            name="modalidad"
                            value={filters.modalidad || ''}
                            onChange={handleFilterChange}
                            options={optionsModalidadDOS}
                            placeholder="Seleccionar..."
                        />
                    </div>
                )}

                {filters.programa_lineamiento === "Financiación para la Capacitación y Difusión de la Gestión del hábitat bonaerense" && (
                    <div>
                        <label htmlFor="modalidad" className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">
                            Modalidad
                        </label>
                        <Select_simple
                            id="modalidad"
                            name="modalidad"
                            value={filters.modalidad || ''}
                            onChange={handleFilterChange}
                            options={optionsModalidadSEIS} //optionsModalidadCUATRO
                            placeholder="Seleccionar..."
                        />
                    </div>
                )}

                {filters.programa_lineamiento === "Proyectos ambientales" && (
                    <div>
                        <label htmlFor="modalidad" className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">
                            Modalidad
                        </label>
                        <Select_simple
                            id="modalidad"
                            name="modalidad"
                            value={filters.modalidad || ''}
                            onChange={handleFilterChange}
                            options={optionsModalidadCUATRO_UNO}
                            placeholder="Seleccionar..."
                        />
                    </div>
                )}

                {(filters.area_responsable === AREA_RESP_MICROCREDITOS || filters.programa_lineamiento === "") && (
                    <div>
                        <label htmlFor="modalidad" className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">
                            Modalidad
                        </label>
                        <select
                            disabled
                            className="w-full p-2 border border-gray-300 dark:border-gray-600 rounded-md shadow-sm dark:bg-gray-700 dark:text-white"
                        >
                            <option>No aplica para este programa</option>
                        </select>
                    </div>
                )}

            </div>

            <div className="grid grid-cols-1 md:grid-cols-3 gap-4">

                {/* Filtro por Estado */}
                <div>
                    <label htmlFor="estado" className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">
                        Estado
                    </label>
                    <Select_simple
                        id="estado"
                        name="estado"
                        value={filters.estado}
                        onChange={handleFilterChange}
                        options={optionsEstado}
                        placeholder="Todos los estados"
                    //className="w-full p-2 border border-gray-300 dark:border-gray-600 rounded-md shadow-sm focus:ring-blue-500 focus:border-blue-500 dark:bg-gray-700 dark:text-white"
                    />
                </div>
                {/* Filtro por Tipo Subsidio */}
                <div>
                    <label htmlFor="tipo_subsidio" className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">
                        Tipo Subsidio
                    </label>
                    <Select_simple
                        id="tipo_subsidio"
                        name="tipo_subsidio"
                        value={filters.tipo_subsidio}
                        onChange={handleFilterChange}
                        options={optionsTipoSubsidio}
                        placeholder="Todos los tipos de subsidio"
                    //className="w-full p-2 border border-gray-300 dark:border-gray-600 rounded-md shadow-sm focus:ring-blue-500 focus:border-blue-500 dark:bg-gray-700 dark:text-white"
                    />
                </div>
                {/* Búsqueda general */}
                <div>
                    <label htmlFor="search" className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">
                        Buscar
                    </label>
                    <div className="relative">
                        <Input
                            type="text"
                            id="search"
                            name="search"
                            value={filters.search}
                            onChange={handleFilterChange}
                            placeholder="Buscar por ID, nombre de obra, exp. proyecto o rendición..."
                            className="w-full pl-10 pr-10 py-2 border border-gray-300 dark:border-gray-600 rounded-md shadow-sm focus:ring-blue-500 focus:border-blue-500 dark:bg-gray-700 dark:text-white"
                        />
                        <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
                            <svg className="h-5 w-5 text-gray-400" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor">
                                <path fillRule="evenodd" d="M8 4a4 4 0 100 8 4 4 0 000-8zM2 8a6 6 0 1110.89 3.476l4.817 4.817a1 1 0 01-1.414 1.414l-4.816-4.816A6 6 0 012 8z" clipRule="evenodd" />
                            </svg>
                        </div>
                        {filters.search && (
                            <button
                                type="button"
                                onClick={() => handleFilterChange({ target: { name: 'search', value: '' } })}
                                className="absolute inset-y-0 right-0 pr-3 flex items-center text-gray-400 hover:text-gray-600 dark:hover:text-gray-300"
                            >
                                <svg className="h-5 w-5" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor">
                                    <path fillRule="evenodd" d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z" clipRule="evenodd" />
                                </svg>
                            </button>
                        )}
                    </div>
                </div>
            </div>
        </div>
    );
};

export default FiltrosInicio;
